module.exports = __webpack_public_path__ + "static/media/pwa.7b3cbff1.svg";